import { Box, Button, Paper, TextField, Typography, Snackbar } from "@mui/material";
import { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import styles from '../../../styles.module.css'
import { Breadcrumb, Cancel, CTSinput, useMessageHandler, HandleCloseSnackbar, ActionMsg } from "../../reusableComponent/Reusables";
import SaveIcon from '@mui/icons-material/Save';
import { useDispatch, useSelector } from "react-redux";
import {  addRoute, editDeleteRoute } from "../../../actions/actions";




const RouteAdd = () => {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.result.userInfo;
    let navigate = useNavigate();
    const { handleSubmit } = useForm();
    const urlLocation = useLocation();
    const editInfo = urlLocation.state;
    const editData = editInfo && editInfo;
    const editid = editData ? editData.r_id : null;
    const [data, setData] = useState({
        route_details: editData ? editData.route_details : '',
        route_id: editData ? editData.route_id : '',
        // uom_id:editData ? editData.uom_id:''
    });

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }

    const [successMessage, setSuccessMessage] = useState(null);
    const respMsgState = useSelector((state) => state.route.message);
    const { shouldShowMsg, responseMessage } = useMessageHandler(null, 
        // navigate,
         setSuccessMessage, respMsgState);

    useEffect(() => {

    }, [shouldShowMsg, responseMessage]);

    const onSubmit = (event) => {
        navigate(-1)
        const RouteData = {
            ...data,
            // company_id: editData ? editData.company_id : userInfo.company_id,
            r_id: editid,
            // jd_po_details: jd_po_details,
            // created_by: editData ? editData.created_by : userInfo.company_id,
            // created_at: editData ? editData.created_at : dateConversionOnEntryPage(new Date()),
            // modified_by: editData ? userInfo.company_id : null,
            // modified_at: dateConversionOnEntryPage(new Date()),
            changedUpdatedValue: 'edit'
        }
        if (editData) {
            dispatch(editDeleteRoute(RouteData));
        } else {
            dispatch(addRoute(RouteData));
        }

    }


    return (
        <>
            <Paper className={`${styles.cts_page}`}>
                <Breadcrumb
                    routeSegments={[
                        { name: 'Route' },
                    ]}
                />
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
                        <Grid item md={7} sm={6} xs={12}>
                            <Box sx={{ display: 'flex' }}>
                                <Typography className={`${styles.add_form_title}`}>
                                    {editData ? 'Update' : 'Create'} Route Master
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Box className={`${styles.sm_form}`} >
                    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '50%', }}>
                        <Grid container spacing={1} sx={{ mt: 0 }} >
                            <Grid item xs={4} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.cts_lable_sm}`}>Route ID <span style={{ color: 'red' }}>*</span> :</Typography>
                            </Grid>
                            <Grid item xs={8} className={`${styles.grid_input}`}>
                                <CTSinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="route_id"
                                    value={(data.route_id)}
                                    sx={{ width: '100%' }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.cts_lable_sm}`}>Route Details :</Typography>
                            </Grid>
                            <Grid item xs={8} className={`${styles.grid_input}`}>
                                <CTSinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="route_details"
                                    value={(data.route_details)}
                                    sx={{ width: '100%' }}
                                />
                            </Grid>
                            <Grid item xs={12} className={`${styles.grid_input}`} >
                                <Box sx={{ marginTop: '12px', float: 'right' }}>
                                    <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                        <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                                    </Button>
                                    <Cancel />
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </Box>
                <Snackbar style={{ zIndex: 9998 }}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage ? true : false}
                    autoHideDuration={2000}
                    onClose={(event, reason) => HandleCloseSnackbar(event, reason, setSuccessMessage)}
                    message={successMessage}
                    action={ActionMsg(setSuccessMessage)}
                />

            </Paper >
        </>
    )
}
export default RouteAdd;